import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.45964 1.5H2.54036C2.40858 1.5 2.29488 1.49999 2.20124 1.50764C2.10241 1.51572 2.0041 1.53355 1.90951 1.58175C1.76839 1.65365 1.65365 1.76839 1.58175 1.90951C1.53355 2.0041 1.51572 2.10241 1.50764 2.20124C1.49999 2.29488 1.5 2.40857 1.5 2.54035V9.45964C1.5 9.59142 1.49999 9.70512 1.50764 9.79876C1.51572 9.89759 1.53355 9.9959 1.58175 10.0905C1.65365 10.2316 1.76839 10.3463 1.90951 10.4183C2.0041 10.4665 2.10241 10.4843 2.20124 10.4924C2.29489 10.5 2.40857 10.5 2.54036 10.5H9.45964C9.59143 10.5 9.70511 10.5 9.79876 10.4924C9.89759 10.4843 9.9959 10.4665 10.0905 10.4183C10.2316 10.3464 10.3464 10.2316 10.4183 10.0905C10.4665 9.9959 10.4843 9.89759 10.4924 9.79876C10.5 9.70511 10.5 9.59143 10.5 9.45964V2.54036C10.5 2.40857 10.5 2.29489 10.4924 2.20124C10.4843 2.10241 10.4665 2.0041 10.4183 1.90951C10.3463 1.76839 10.2316 1.65365 10.0905 1.58175C9.9959 1.53355 9.89759 1.51572 9.79876 1.50764C9.70512 1.49999 9.59142 1.5 9.45964 1.5Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }